import React from 'react';

import s from './style.module.css';

type Item = {
    id: number;
    name: string;
    url: string;
};

type UnorderedListProps = {
    items: Item[];
};

export const UnorderedList = (props: UnorderedListProps) => {
    return (
        <ul className={s.list}>
            {props.items.map((item) =>
                item.url ? (
                    <li key={item.id} className={s.not_inline}>
                        <a className={s.link} href={item.url} target='_blank' rel='noreferrer'>
                            {item.name}
                        </a>
                    </li>
                ) : (
                    <li key={item.id}>{item.name}</li>
                )
            )}
        </ul>
    );
};
